import { api } from './client'

// GET /api/v1/notifications — list + unread count
export const listNotifications = () =>
  api.get('/notifications').then((r) => r.data)

// GET /api/v1/notifications/unread-count — just the badge number
export const unreadNotifCount = () =>
  api.get('/notifications/unread-count').then((r) => r.data.count)

// POST /api/v1/notifications/:id/read
export const markNotifRead = (id) =>
  api.post(`/notifications/${id}/read`).then((r) => r.data)

// POST /api/v1/notifications/read-all
export const markAllNotifsRead = () =>
  api.post('/notifications/read-all').then((r) => r.data)
